import { render } from "./SavedPopup.vue?vue&type=template&id=383c56d6"
import script from "./SavedPopup.vue?vue&type=script&lang=js"
export * from "./SavedPopup.vue?vue&type=script&lang=js"

import "./SavedPopup.vue?vue&type=style&index=0&id=383c56d6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__